<template>
  <header class="dashboard-header">
    <div
      class="back-button"
      v-on:click="handleBackButton"
      v-if="
        this.title === 'Pages'
        || this.title === 'Components'
        || this.window.location.pathname.includes('/applications/')
        || this.$route.name === 'tip'
        || this.$route.name === 'momentstrategy'
        || this.$route.name === 'sections'
        || this.$route.name === 'questions'
        || this.$route.name === 'options'
      "
    >    
      <BackButtonIcon/>
    </div>

    <h1>{{ title }}</h1>

    <p
      v-if="hideApplicationSelection()"
      class="select-application"
    >
      Select application:
    </p>

    <Dropdown
      v-if="hideApplicationSelection()"
      :title="selectedApplicationName"
    >
      <DropdownSearch :list="applications"/>
    </Dropdown>

    <div 
      class="header--menu"
      v-on:click="$emit('handleNavigation')"
    >
      <MenuIcon/>
    </div>    
  </header>
</template>

<script>
  import { API } from '../../../services/api.ts'
  import Dropdown from '../../dropdown/dropdown.vue'
  import DropdownSearch from '../../dropdown/content/search.vue'
  import MenuIcon from '../../../icons/menu.vue'
  import BackButtonIcon from '../../../icons/backButton.vue'

  export default {
    name: 'Header',
    props: [
      'title'
    ],
    components: {
      Dropdown,
      DropdownSearch,
      MenuIcon,
      BackButtonIcon
    },
    data() {
      return {
        selectedApplicationName: 'Select application',
        applications: [],
        window: window
      }
    },
    methods: {
      handleBackButton: function() {
        let path = window.location.pathname;

        if (window.location.pathname.includes("/applications/")) {
          path = '/applications';
        } else if (this.title === 'Pages') {
          path = '/lessons'
        } else if (this.title === 'Components') {
          path = path.slice(0, path.length - 16);
        } else if (this.$route.name === 'tip') {
          path = '/modules/tips';
        } else if (this.$route.name === 'momentstrategy') {
          path = '/modules/moments';
        } else if (this.$route.name === 'sections') {
          path = '/questionnaires';
        } else if (this.$route.name === 'questions') {
          path = `/questionnaires/sections/${this.$route.params.id}`;
        } else if (this.$route.name === 'options') {
          path = `/questionnaires/sections/${this.$route.params.id}/questions/${this.$route.params.questionid}`;
        }

        window.location.href = path;
      },
      hideApplicationSelection: function() {
        switch (this.$route.name) {
          case 'applications':
            return false
            break;

          case 'application':
            return false
            break;

          case 'users':
            return false
            break;
          
          case 'images':
            return false
            break;

          case 'videos':
            return false
            break;

          case 'documents':
            return false
            break;
        
          default:
            return true
            break;
        }
      }
    },
    mounted() {
      // selected application
      if(localStorage.selectedApplicationName) {
        this.selectedApplicationName = localStorage.selectedApplicationName;
      }

      // api
      API.get(
        'index.cfm?act=applications.list'
      ).then(
        response => {
          this.applications = response.data.data;

          if (response.data.data.length === 0) {
            this.selectedApplicationName = 'Select application';
          }
        } 
      )
    }
  }
</script>

<style lang="scss">
  @import "../../../styles/components/mediaQueries.scss";

  .dashboard-header {
    height: 60px;
    position: fixed;
    top: 0;
    left: var(--navigation-width);
    width: calc(100% - var(--navigation-width));
    background-color: var(--white);
    z-index: 2;
    border-bottom: 1px solid #2020240a;
    padding-left: 30px;

    @include media-sm {
      height: 40px;
      padding-left: 15px;
    }

    .back-button {
      float: left;
      margin-right: 15px;
      margin-top: 23px;
      cursor: pointer;

      @include media-sm {
        margin-top: 13px;
      }
    }

    h1 {
      float: left;
      margin-top: 15px;

      @include media-sm {
        margin-top: 8px;
      }
    }

    .select-application {
      margin-top: 20px;
      position: absolute;
      right: 264px;
      font-weight: bold;

      @include media-sm {
        display: none;
      }
    }

    .dropdown {
      position: absolute;
      right: 30px;
      top: 15px;
      width: 220px;

      @include media-sm {
        top: 5px;
        right: 45px;
        width: 135px;
      }

      &--button {
        font-size: 13px;
        padding: 5px 6px;
      }
    }

    .header--menu {
      position: absolute;
      top: 13px;
      right: 15px;
      display: none;
      cursor: pointer;

      @include media-sm {
        display: block;
      }
    }
  }
</style>